export const ConsumerPhoneNumberFormUat = {
  field: 'workflow.consumerPhoneNumber.field',
  errorMessage: 'workflow.consumerPhoneNumber.errorMessage',
  submitButton: 'workflow.consumerPhoneNumber.submitButton'
}
